import {
  dateOperating
} from '@/cllib/tools'

import {
  invoicingGetData,
  invoicingUpdateData,
  invoicingCheckUpdateDailyAndOrder,
  invoicingCheckownFile,
  distributionGasTransfer
} from '@/api/api'

const state = {
  errorInvoicingList: [],
  errorInvoicingListLoading: false,
  chooseErrorInvoicing: {},
  errorInvoicingSearchDate: [],
  invoicingCheckLoadPiTag: 1,
  invoicingCheckPiGasTankId: 0,
  updateAllLoading: false
}

const getters = {
  updateAllLoading: state => state.updateAllLoading,
  invoicingCheckLoadPiTag: state => state.invoicingCheckLoadPiTag,
  invoicingCheckPiGasTankId: state => state.invoicingCheckPiGasTankId,
  errorInvoicingList: state => state.errorInvoicingList,
  errorInvoicingListLoading: state => state.errorInvoicingListLoading,
  chooseErrorInvoicing: state => state.chooseErrorInvoicing,
  chooseErrorInvoicingCollectTime: state => state.chooseErrorInvoicing.collectTime || null,
  errorInvoicingSearchDate: state => state.errorInvoicingSearchDate
}

const actions = {
  loadErrorInvoicingList ({ dispatch, getters }) {
    if (!getters.errorInvoicingSearchDate) {
      dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '请选择采集时间'})
      return
    }
    dispatch('setErrorInvoicingListLoading', true)
    let parm = {
      noPage: 1,
      mergeIdnull: 1,
      collectTime: dateOperating.formatDate({date: getters.errorInvoicingSearchDate[0], format: 'yy-mm-dd'}),
      endTime: dateOperating.computeDay({days: 1, date: getters.errorInvoicingSearchDate[1], format: 'yy-mm-dd'}),
      groupId: getters.currentGroupId
    }
    return invoicingGetData(parm).then((data) => {
      data.forEach((item) => {
        item['oilTypeJ'] = item.oilType ? (item.oilType.split('号')[0] + '#') : ''
        item['collectTimeJ'] = item.collectTime ? item.collectTime.slice(5, 10) : ''
      })
      dispatch('setErrorInvoicingList', data)
      dispatch('setErrorInvoicingListLoading', false)
    }).catch((e) => {
      dispatch('setErrorInvoicingListLoading', false)
    })
  },
  updateAll ({ getters, dispatch }) {
    let updateDistributions = []
    let updateGasDailies = []
    for (let key in getters.upadteRelatedinvoicing) {
      updateGasDailies.push(getters.upadteRelatedinvoicing[key])
    }
    for (let key in getters.updateRelatedDistribution) {
      updateDistributions.push(getters.updateRelatedDistribution[key])
    }
    if (updateDistributions.length === 0 && updateGasDailies.length === 0) {
      dispatch('showNoticeMsg', {type: 'info', title: '系统提示', message: '未修改配送单，无效保存'})
      return
    }
    dispatch('setUpdateAllLoading', true)
    let parm = {
      distributions: updateDistributions,
      gasDailies: updateGasDailies
    }
    invoicingCheckUpdateDailyAndOrder(parm).then((data) => {
      dispatch('loadErrorInvoicingList')
      dispatch('loadRelatedinvoicing')
      dispatch('loadRelatedDistribution')
      dispatch('setInvoicingCheckPiGasTankId', getters.chooseErrorInvoicing.gasTankId || null)
      dispatch('setUpdateAllLoading', false)
    }).catch((e) => {
      dispatch('setUpdateAllLoading', false)
    })
  },
  updateInvoicingData ({ dispatch }, parm) {
    return invoicingUpdateData(parm)
  },
  distributionGasTransfer ({ dispatch }, parm) {
    return distributionGasTransfer(parm)
  },
  invoicingCheckownFile ({ dispatch }, parm) {
    return invoicingCheckownFile(parm)
  },
  setErrorInvoicingListLoading ({ commit }, data) {
    commit('setErrorInvoicingListLoading', data)
  },
  setInvoicingCheckPiGasTankId ({ commit, dispatch }, data) {
    commit('setInvoicingCheckPiGasTankId', data)
    dispatch('updateInvoicingCheckLoadPiTag')
  },
  updateInvoicingCheckLoadPiTag ({ commit, getters }) {
    commit('setInvoicingCheckLoadPiTag', getters.invoicingCheckLoadPiTag + 1)
  },
  setErrorInvoicingList ({ commit }, data) {
    commit('setErrorInvoicingList', data)
  },
  setUpdateAllLoading ({ commit }, data) {
    commit('setUpdateAllLoading', data)
  },
  setChooseErrorInvoicing ({ commit, dispatch, getters }, data) {
    let editData = 0
    for (let key in getters.updateRelatedDistribution) {
      editData += (1 || key)
    }
    for (let key in getters.upadteRelatedinvoicing) {
      editData += (1 || key)
    }
    if (editData > 0) {
      dispatch('showNoticeMsg', {type: 'warning', title: '系统提示', message: '请先保存已调整数！'})
      return
    }
    commit('setChooseErrorInvoicing', data)
    dispatch('setInvoicingCheckPiGasTankId', data.gasTankId || null)
    dispatch('loadRelatedinvoicing')
    dispatch('loadRelatedDistribution')
  },
  setErrorInvoicingSearchDate ({ commit, dispatch }, data) {
    commit('setErrorInvoicingSearchDate', data)
  },
  updateErrorInvoicingOne ({ commit, dispatch }, data) {
    commit('updateErrorInvoicingOne', data)
  },
  updateErrorInvoicingError ({ commit, dispatch }, data) {
    commit('updateErrorInvoicingError', data)
  }
}

const mutations = {
  setErrorInvoicingListLoading (state, data) {
    state.errorInvoicingListLoading = data
  },
  setUpdateAllLoading (state, data) {
    state.updateAllLoading = data
  },
  setInvoicingCheckLoadPiTag (state, data) {
    state.invoicingCheckLoadPiTag = data
  },
  setInvoicingCheckPiGasTankId (state, data) {
    state.invoicingCheckPiGasTankId = data
  },
  setErrorInvoicingList (state, data) {
    state.errorInvoicingList = data
  },
  setChooseErrorInvoicing (state, data) {
    state.chooseErrorInvoicing = data
  },
  setErrorInvoicingSearchDate (state, data) {
    state.errorInvoicingSearchDate = data
  },
  updateErrorInvoicingError (state, id) {
    state.errorInvoicingList.forEach((item) => {
      if (item.id === id) {
        item.isError = false
        item.errorText = item.isError ? '异常' : ''
      }
    })
  },
  updateErrorInvoicingOne (state, data) {
    state.errorInvoicingList.forEach((item) => {
      if (item.gasTankId === data.his.gasTankId) {
        let startTime = dateOperating.computeDay({days: -1, date: item.collectTime, format: 'stamps'})
        let endTime = dateOperating.computeDay({days: 0, date: item.collectTime, format: 'stamps'})
        let hisInTime = data.his.inTime ? dateOperating.formatDate({date: data.his.inTime, format: 'stamps'}) : null
        if (hisInTime && hisInTime > startTime && (hisInTime < endTime || hisInTime === endTime)) {
          item.inVolume = item.inVolume - data.his.inVolume
          item.inVolume = item.inVolume < 10 && item.inVolume > -10 ? 0 : item.inVolume
          item.nowErrorVolume = parseInt(item.startInventory - item.outVolume + item.inVolume - item.endInventory)
        }
        let newInTime = data.new.inTime ? dateOperating.formatDate({date: data.new.inTime, format: 'stamps'}) : null
        if (newInTime && newInTime > startTime && (newInTime < endTime || newInTime === endTime)) {
          item.inVolume = item.inVolume + data.new.inVolume
          item.nowErrorVolume = parseInt(item.startInventory - item.outVolume + item.inVolume - item.endInventory)
        }
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/dispatch/invoicing_check/error_invoicing.js